/**
 * 非同期通信でのエラーメッセージに日本語のエラー文言を追加する
 * @param { Object } error - axiosでの通信失敗時に返却されるオブジェクト
 * @return { Object } 日本語のエラー文言を追加
 **/

export default error => {
  // エラーメッセージ定義
  const errorMessage = {
    timeout: `通信に失敗しました。お手数ですが時間を置いて再度アクセスするか、通信環境の良い場所で再度お試しください。`,
    disconnected: 'ネットワークに接続されていません。'
  }

  if (error.code === 'ECONNABORTED') {
    // タイムアウト
    error.message = errorMessage.timeout
  } else if (!error.code) {
    // ネットワーク接続エラー
    error.message = errorMessage.disconnected
  }
  return error
}



// WEBPACK FOOTER //
// ./resources/assets/js/utils/pushErrorMessage.js